<!--
 * @Descripttion: 销售统计
 * @version: 
 * @Author: alex.yang
 * @Date: 2023-12-19 17:41:21
 * @LastEditors: alex.yang
 * @LastEditTime: 2023-12-27 09:35:32
-->
<template>
    <div class="marketStatistics">
        <div class="ms-title-screen">
            <div class="sr-item">
                <el-select v-model="years" @change="changeYear">
                    <el-option
                    v-for="item in yearArray"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
                <el-select v-model="month" @change="changeMonth">
                    <el-option
                    v-for="item in monthArray"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
            </div>
            <div class="sr-item">
                <div class="i-title">销售类型</div>
                <el-select v-model="marketValue" @change="changeType">
                    <el-option
                    v-for="item in marketOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="ms-content">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="ranking" label="排名"></el-table-column>
                <el-table-column prop="open_price" label="开通金额"></el-table-column>
                <el-table-column prop="open_num" label="开通商户数"></el-table-column>
                <el-table-column label="续费金额" prop="renew_price">
                    <template slot-scope="scope">
                        <div>
                            <div v-if="scope.row.count_renew == 1">{{scope.row.renew_price}}</div>
                            <div v-else><i class="el-icon-minus"></i><i class="el-icon-minus"></i></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="续费商户数" prop="renew_num">
                    <template slot-scope="scope">
                        <div>
                            <div v-if="scope.row.count_renew == 1">{{scope.row.renew_num}}</div>
                            <div v-else><i class="el-icon-minus"></i><i class="el-icon-minus"></i></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="绩效金">
                    <template slot-scope="scope">
                        <div>{{scope.row.performance_price}}({{scope.row.performance_rate}}%)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="price" label="提成">
                    <template slot-scope="scope">
                        <div>{{scope.row.commission_price}}({{scope.row.commission}}%)</div>
                    </template>
                </el-table-column>
                <el-table-column label="姓名" prop="name"></el-table-column>
                <el-table-column label="联系方式" prop="phone"></el-table-column>
                <el-table-column label="销售类型" prop="type"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import api from "@/utils/common.js"
import pageMixin from '@/internal/pageMixin'
export default {
    mixins:[pageMixin],
    data () {
        return {
            pageMixin_index:'marketStatistics',
            yearArray: [],
            years: '',
            monthArray: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月',],
            month: '',
            marketOptions: [],
            marketValue: '',
            tableData: [],
            monthData: '',
            yearData: ''
        }
    },
    mounted () {
        // 获取最近十年的年份数组
        var currentYear = new Date().getFullYear();
        var yearArray = [];
        var yearArr = [];
        for (var i = 0; i < 10; i++) {
            yearArray.push((currentYear - i)+'年');
            yearArr.push((currentYear - i));
        }
        this.years = yearArray[0]
        this.yearData = yearArr[0]
        this.yearArray = yearArray;

        // 获取当前的月份
        var currentDate = new Date();
        var currentMonth= currentDate.getMonth() +1;
        this.month = currentMonth + '月'
        this.monthData = currentMonth
        this.getSaleTypeWhole()
        this.getSaleCount();
    },
    methods: {
        // 选择销售类型
        changeType(){
            this.getSaleCount()
        },
        // 选择月
        changeMonth(){
            this.monthData = this.month.replace('月', '');
            this.getSaleCount()
        },
        // 选择年
        changeYear(){
            this.yearData = this.years.replace('年', '');
            this.getSaleCount()
        },
        // 获取销售统计数据
        getSaleCount(){
            let params = {
                page_num: 1,
                page_size: 100,
                year: this.yearData,
                month: this.monthData,
                type_id: this.marketValue,
            }
            api.get('/service/sale/sale_count', params, (res) =>  {
                this.tableData = res.data.list
            });
        },
        // 获取销售类型
        getSaleTypeWhole(){
            api.get('/service/sale/get_sale_type_whole', {}, (res) =>  {
                let resultSecond =  res.data.list.map(v =>{
                return{
                    id: v.id,
                    name: v.name,
                }
                })
                let quan = {
                    id: '',
                    name: '全部',
                }
                resultSecond.unshift(quan);
                this.marketOptions = resultSecond
            });
        },
    },
}
</script>

<style lang='scss'>
.marketStatistics{
    .ms-title-screen{
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #fff;
        padding: 15px 40px 0 40px;
        .sr-item{
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            margin-right: 30px;
            padding-bottom: 15px;
            .i-title{
                font-size: 16px;
                color: #0a032d;
            }
            .el-select{
                width: 150px;
                padding-left: 20px;
            }
        }
    }
    .ms-content{
        margin: 20px;
        background: #fff;
        padding: 20px;
        border-radius: 8px;
        .code{
            text-align: center;
            width: 150px;
            padding: 5px 20px;
            border: 1px solid #ddd;
            background: #e6effd;
            border-radius: 9px;
        }
        .btn-wrap{
            display: flex;
            justify-content: center;
            align-items: center;
            .btn{
                padding: 0 15px;
                cursor: pointer;
                font-size: 14px;
                color: #0068ff;
            }
        }
    }
}
</style>
